export enum AIProviderType {
  OpenAI = 'openai',
  AzureOpenAI = 'azureopenai',
  SnowflakeCortex = 'snowflakecortex',
  SnowflakeCortexAPI = 'snowflakecortexapi',
  GoogleGemini = 'googlegemini',
  AnthropicClaude = 'anthropicclaude',
  FireworksAI = 'fireworksai',
  AstratoDefault = 'astrato-default',
}
